import { CLEAR_FROM_LOCAL, SAVE_TO_LOCAL } from "../constants/action_types";
import { all, takeEvery } from "redux-saga/effects";

function* saveToLocal(action) {
  try {
    for (let item of action.items) {
      yield localStorage.setItem(item[0], item[1]);
    }
  } catch (error) {
    console.log(error.message);
  }
}

function* clearFromLocal(action) {
  try {
    for (let key of action.keys) {
      if (key instanceof RegExp) {
        for (var i = 0, len = localStorage.length; i < len; ++i) {
          key.test(localStorage.key(i)) &&
            localStorage.clear(localStorage.key(i));
        }
      } else yield localStorage.removeItem(key);
    }
  } catch (error) {
    console.log(error.message);
  }
}

function* localStorageWatcherSaga() {
  yield all([
    takeEvery(SAVE_TO_LOCAL, saveToLocal),
    takeEvery(CLEAR_FROM_LOCAL, clearFromLocal),
  ]);
}

export default localStorageWatcherSaga;
